import React, { useState, useEffect } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Pagination,
  TextField,
  Button,
  Tooltip,
} from "@mui/material";
import instance from "../../utils/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import Topbar from "../../Layouts/Admin_layout/Admin_topbar";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import RoomIcon from "@mui/icons-material/Room";
import { toast } from "react-toastify";
import { formatDate } from "../../utils/helper";

const TruncatedText = ({ text }) => {
  if (!text) return "-";
  const display = text.length > 20 ? text.substring(0, 20) + "..." : text;
  return text.length > 20 ? (
    <Tooltip title={text}>
      <span>{display}</span>
    </Tooltip>
  ) : (
    <span>{text}</span>
  );
};

const addressCache = new Map();

const AddressCell = ({ lat, lon }) => {
  const [address, setAddress] = useState(`Lat: ${lat}, Lon: ${lon}`);

  useEffect(() => {
    if (!lat || !lon) return;
    const key = `${lat},${lon}`;
    if (addressCache.has(key)) {
      setAddress(addressCache.get(key));
      return;
    }

    const timer = setTimeout(async () => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
        );
        const data = await response.json();
        if (data && data.display_name) {
          addressCache.set(key, data.display_name);
          setAddress(data.display_name);
        }
      } catch (err) {
        // Fallback to lat/lon on error
      }
    }, Math.random() * 2000); // spread requests to respect rate limits

    return () => clearTimeout(timer);
  }, [lat, lon]);

  return <TruncatedText text={address} />;
};

function FieldOfficerscheckins() {
  // const { hash } = useParams();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash");
  const name = searchParams.get("name");
  const email = searchParams.get("email");
  const navigate = useNavigate();
  const [filedofficerDetails, setFieldOfficersDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Set items per page
  const [selectedDate, setSelectedDate] = useState(dayjs().startOf("month"));

  // Format the selected date as 'YYYY-MM' before using in the API request
  const formattedSelectedDate = selectedDate.format("YYYY-MM");

  //fetch getEmployeeCheckinouts
  const getFiledpfficerCheckinouts = async () => {
    try {
      const response = await instance.get(
        `field_officer/getAttendence?fieldofficer_hash=${hash}&date=${formattedSelectedDate}`
      );
      setFieldOfficersDetails(response.data.data);
    } catch (error) {
      toast.error("Error fetching Filedofficer details:", error.message);
    }
  };

  useEffect(() => {
    getFiledpfficerCheckinouts();
  }, []);

  const handleSubmit = () => {
    getFiledpfficerCheckinouts();
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filedofficerDetails.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filedofficerDetails.length / itemsPerPage);

  return (
    <div>
      <div style={{ padding: "20px 20px 0px 0px" }}>
        <Topbar />
      </div>
      <section style={{ padding: "20px 20px 0px 0px" }}>
        <div className="container-fluid">
          <div className="table_box">
            <TableContainer component={Paper}>
              <div className="table_inbox">
                <div className="add_user_list">
                  <div className="add_user_content">
                    <div
                      className="header-back"
                      style={{
                        fontFamily: "Poppins,sans-serif",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      Field Officers Checkins
                      <button
                        className="back-btn"
                        onClick={() => navigate("/admin/FieldOfficers")}
                      >
                        Back
                      </button>
                    </div>
                    <div className="checkin-details">
                      <h5>
                        <span>Email: </span> {email}
                      </h5>
                      <h5>
                        <span>Filedofficer Name:</span> {name}
                      </h5>
                    </div>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            label="Select Year and Month"
                            value={selectedDate}
                            views={["month", "year"]}
                            onChange={(newValue) => setSelectedDate(newValue)}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <button
                        className="back-btn"
                        style={{ marginLeft: "20px" }}
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
                <div className="adduser_table">
                  <Table
                    className="user_table product_table"
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow className="table_head">
                        <TableCell className="second-child">Date</TableCell>
                        <TableCell>checkIn Location</TableCell>
                        <TableCell>checkIn Time</TableCell>
                        <TableCell>checkout Location</TableCell>
                        <TableCell>checkout Time</TableCell>
                        <TableCell align="center">checkIn map</TableCell>
                        <TableCell align="center">checkout map</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="table_body">
                      {currentItems.length > 0 ? (
                        currentItems.map((field) => {
                          // Detect system auto-checkout (location is '--' or null, time is 12:05 AM)
                          const isSystemCheckout = field?.check_out?.time && 
                            (field.check_out.time.includes('12:05') && field.check_out.time.toUpperCase().includes('AM')) &&
                            (!field.check_out.location || field.check_out.location === '--');
                          
                          return (
                          <TableRow key={field._id}>
                            <TableCell align="left">{formatDate(field.date)}</TableCell>
                            <TableCell align="left">
                              {field?.check_in?.location
                                ? <TruncatedText text={field.check_in.location} />
                                : field?.check_in?.latitude && field?.check_in?.longitude
                                  ? <AddressCell lat={field.check_in.latitude} lon={field.check_in.longitude} />
                                  : "-"}
                            </TableCell>
                            <TableCell align="left">
                              {field?.check_in?.time ? field?.check_in?.time
                                ?.split(":")
                                .slice(0, 2)
                                .join(":") +
                                " " +
                                field?.check_in?.time?.split(" ")[1] : "-"}
                            </TableCell>
                            <TableCell align="left" style={isSystemCheckout ? { color: '#f44336', fontWeight: 'bold' } : {}}>
                              {isSystemCheckout 
                                ? <span style={{ color: '#f44336', fontWeight: 'bold' }}>System Checkout</span>
                                : field?.check_out?.location
                                  ? <TruncatedText text={field.check_out.location} />
                                  : field?.check_out?.latitude && field?.check_out?.longitude
                                    ? <AddressCell lat={field.check_out.latitude} lon={field.check_out.longitude} />
                                    : "-"}
                            </TableCell>
                            <TableCell align="left" style={isSystemCheckout ? { color: '#f44336', fontWeight: 'bold' } : {}}>
                              {isSystemCheckout 
                                ? <span style={{ color: '#f44336', fontWeight: 'bold' }}>12:05 AM (Auto)</span>
                                : field?.check_out?.time ? field?.check_out?.time
                                  ?.split(":")
                                  .slice(0, 2)
                                  .join(":") +
                                  " " +
                                  field?.check_out?.time?.split(" ")[1] : "-"}
                            </TableCell>
                            <TableCell align="center">
                              {field?.check_in?.latitude && field?.check_in?.longitude ? (
                                <Tooltip title="checkIn map">
                                  <a style={{ color: "#78c144" }}
                                    href={`https://www.google.com/maps/place/${field?.check_in?.latitude}+${field?.check_in?.longitude}`}
                                    target="blank"
                                  >
                                    <RoomIcon />
                                  </a>
                                </Tooltip>
                              ) : "-"}
                            </TableCell>
                            <TableCell align="center">
                              {isSystemCheckout 
                                ? <Tooltip title="System Auto-Checkout - No location">
                                    <span style={{ color: '#f44336' }}>
                                      <RoomIcon style={{ opacity: 0.5 }} />
                                    </span>
                                  </Tooltip>
                                : field?.check_out?.latitude && field?.check_out?.longitude ? (
                                  <Tooltip title="checkout map">
                                    <a style={{ color: "#78c144" }}
                                      href={`https://www.google.com/maps/place/${field?.check_out?.latitude}+${field?.check_out?.longitude}`}
                                      target="blank"
                                    >
                                      <RoomIcon />
                                    </a>
                                  </Tooltip>
                                ) : "-"}
                            </TableCell>
                          </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={12} align="center">
                            No data available for the selected month and year.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </div>
                <div className="pagination_table">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    shape="rounded"
                    variant="outlined"
                  />
                </div>
              </div>
            </TableContainer>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FieldOfficerscheckins;
